import _ from 'lodash'
import type {DocumentManager} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import * as constants from '../../../../../constants/constants'
import {runOnPageComponents} from '../utils/migrationUtil'
import * as removeStyleIdForComps from './removeStyleIdUnstylableComps'
import * as sectionMigrations from './sectionMigrations'
import type {PageMigrator} from '../../dataMigrationRunner'

const componentMigrators = {
    ...removeStyleIdForComps.components,
    ...sectionMigrations.components
}

const migrateComponent = (documentManager: DocumentManager, pageId: string, pointer: Pointer, viewMode: string) => {
    const compStructure = documentManager.dal.get(pointer)
    const {componentType} = compStructure
    componentMigrators[componentType]?.(documentManager, pointer, compStructure, viewMode)
}

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    _.forEach(constants.VIEW_MODES, viewMode => {
        runOnPageComponents(documentManager, pageId, viewMode, migrateComponent)
    })
}

const name = 'runComponentSpecificMigrations'
const version = 3

export const runComponentSpecificMigrations: PageMigrator = {
    migratePage,
    name,
    version,
    fixerRequiresReruns: true
}
